import script from "./ManageMemoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageMemoryModal.vue?vue&type=script&setup=true&lang=js"

import "./ManageMemoryModal.vue?vue&type=style&index=0&id=804cec02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-804cec02"]])

export default __exports__